<style lang="scss">
.el-submenu .el-menu-item {
	background-color: #2B3140 !important;
}

.el-submenu .el-menu-item:hover {
	background-color: #242831 !important;
}

.el-submenu .el-submenu__title {
	background-color: #2B3140 !important;
}

.el-submenu .el-submenu__title:hover {
	background-color: #242831 !important;
}

// 去掉el-input的背景色和边框 - 全局样式
.dynamic-nav-container .el-input .el-input__inner {
	background-color: transparent !important;
	border: none !important;
	box-shadow: none !important;
	outline: none !important;
}

.dynamic-nav-container .el-input .el-input__inner:focus {
	border: none !important;
	box-shadow: none !important;
	outline: none !important;
}

.dynamic-nav-container .el-input .el-input__inner:hover {
	border: none !important;
	outline: none !important;
}

// 搜索图标样式
.dynamic-nav-container .el-input .el-input__prefix {
	color: white !important;
}

.dynamic-nav-container .el-input .el-input__prefix i {
	color: white !important;
}

// 输入框文字颜色
.dynamic-nav-container .el-input .el-input__inner {
	color: white !important;
}

.dynamic-nav-container .el-input .el-input__inner::placeholder {
	color: rgba(255, 255, 255, 0.6) !important;
}

// 导航栏字体大小样式
.dynamic-nav-container .el-menu-item span,
.dynamic-nav-container .el-submenu__title span {
	transition: font-size 0.3s ease;
}

// 中文语言字体大小
.dynamic-nav-container[data-lang="zh_CN"] .el-menu-item span,
.dynamic-nav-container[data-lang="zh_CN"] .el-submenu__title span {
	font-size: 14px !important;
}

// 其他语言字体大小
.dynamic-nav-container[data-lang="en_US"] .el-menu-item span,
.dynamic-nav-container[data-lang="en_US"] .el-submenu__title span,
.dynamic-nav-container[data-lang="de_DE"] .el-menu-item span,
.dynamic-nav-container[data-lang="de_DE"] .el-submenu__title span,
.dynamic-nav-container[data-lang="ru_RU"] .el-menu-item span,
.dynamic-nav-container[data-lang="ru_RU"] .el-submenu__title span,
.dynamic-nav-container[data-lang="vi_VN"] .el-menu-item span,
.dynamic-nav-container[data-lang="vi_VN"] .el-submenu__title span {
	font-size: 12px !important;
}
</style>
<template>
	<div class="dynamic-nav-container" :data-lang="currentLanguage">
		<el-input v-if="isFirst && store.state.is_sidebar_open" clearable :size="'mini'" v-model="searchTxt" :placeholder="$t('sousuo')" prefix-icon="el-icon-search" style="width: calc(100% - 20px);margin-left: 10px;"></el-input>
		<template v-for="item in filteredMenuList">
			<!-- <template v-if="item.show=='true'"> -->
			<el-submenu v-if="item.children" :key="item.id" :index="item.id + ''" v-show="item.visible">
				<template slot="title">
					<i style="font-size: 15px;margin-right: 10px;color: white;" :class="[item.icon ? 'yicon yicon-' + item.icon : '']"></i>
					<span :style="{ fontSize: navFontSize }">{{ $t(item.code) }}</span>
				</template>
				<dynamic_nav :menuList="item.children" :search="searchTxt" />
			</el-submenu>
			<el-menu-item v-else :route="{ path: item.route }" :key="item.id + ''" :index="item.route" v-show="item.visible">
				<i style="font-size: 15px;margin-right: 10px;color: white;" v-if="item.icon" :class="[item.icon ? 'yicon yicon-' + item.icon : '']"></i>
				<span :style="{ fontSize: navFontSize }">{{ $t(item.code) }}</span>
			</el-menu-item>
			<!-- </template> -->
		</template>
	</div>
</template>

<script>
export default {
	name: 'dynamic_nav', //必须要 递归组件的关键，并且要与引入组件的变量名称一致
	data() {
		return {
			searchTxt: '',
			current_open: []
		};
	},
	props: {
		isFirst: {
			type: Boolean,
			default: false
		},
		menuList: [],
		search: {
			type: String,
			default: ''
		}
	},
	computed: {
		filteredMenuList() {
			if (!this.searchTxt || this.searchTxt.trim() === '') {
				return this.menuList;
			}

			const searchTerm = this.searchTxt.toLowerCase().trim();
			return this.menuList.filter(item => {
				// 检查当前菜单项是否匹配
				const currentMatch = this.$t(item.code).toLowerCase().includes(searchTerm);

				// 如果有子菜单，检查子菜单是否匹配
				if (item.children && item.children.length > 0) {
					const hasMatchingChildren = this.hasMatchingChildren(item.children, searchTerm);
					return currentMatch || hasMatchingChildren;
				}

				return currentMatch;
			});
		},
		// 检测当前语言
		currentLanguage() {
			return localStorage.getItem('lang') || 'zh_CN';
		},
		// 根据语言返回字体大小
		navFontSize() {
			return this.currentLanguage === 'zh_CN' ? '14px' : '12px';
		}
	},
	methods: {
		hasMatchingChildren(children, searchTerm) {
			return children.some(child => {
				const childMatch = this.$t(child.code).toLowerCase().includes(searchTerm);

				if (child.children && child.children.length > 0) {
					return childMatch || this.hasMatchingChildren(child.children, searchTerm);
				}

				return childMatch;
			});
		}
	},
	created() {
		//console.log(this.menuList)
		//找出当前打开的
		// setTimeout(() => {
		//   this.$router.push('/admin/system/qiniu_file')
		// }, 5000);
		this.searchTxt = this.search;
	},
	watch: {
		search(newVal) {
			this.searchTxt = newVal;
		}
	}
};
</script>
